import { NavLink } from 'react-router-dom';
import { NAV_LINKS } from '../../config/navigation';

export default function NavLinks() {
  return (
    <div className="hidden lg:flex items-center gap-10">
      {NAV_LINKS.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `text-[12.5px] transition-colors duration-300 ${
              isActive
                ? 'text-cyan-400 font-medium'
                : 'text-white/90 hover:text-cyan-300 font-regular'
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}